import { ImageTemplates } from "~/components/image/types";
import { WindowFormat } from "~/context/breakpoints/types";

export const imageTemplates: ImageTemplates = {
  [WindowFormat.mobile]: "storedepartmentimage-mobile",
  [WindowFormat.tablet]: "storedepartmentimage-tablet",
  [WindowFormat.desktop]: "storedepartmentimage-regulardesktop",
  [WindowFormat.wideDesktop]: "storedepartmentimage-largedesktop",
};

const STORE_DEPARTMENT_WITH_IMAGE_PREFIX = "StoreDepartmentWithImage";

export const STORE_DEPARTMENT_WITH_IMAGE_CLASSES = {
  root: `${STORE_DEPARTMENT_WITH_IMAGE_PREFIX}-root`,
  text: `${STORE_DEPARTMENT_WITH_IMAGE_PREFIX}-text`,
  name: `${STORE_DEPARTMENT_WITH_IMAGE_PREFIX}-name`,
  floor: `${STORE_DEPARTMENT_WITH_IMAGE_PREFIX}-floor`,
  image: `${STORE_DEPARTMENT_WITH_IMAGE_PREFIX}-image`,
};
